import { render, staticRenderFns } from "./monitor-center.vue?vue&type=template&id=c8cb9bec&scoped=true"
import script from "./monitor-center.vue?vue&type=script&lang=js"
export * from "./monitor-center.vue?vue&type=script&lang=js"
import style0 from "./monitor-center.vue?vue&type=style&index=0&id=c8cb9bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cb9bec",
  null
  
)

export default component.exports